// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyB1fRRN20vtwMvsHrU782drnYLu81IAt5g',
    authDomain: 'sharingfoodmate.firebaseapp.com',
    projectId: 'sharingfoodmate',
    storageBucket: 'sharingfoodmate.appspot.com',
    messagingSenderId: '194087581466',
    appId: '1:194087581466:web:234d394d05b559db40dea3',
    measurementId: 'G-WV2N419YR5',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
